import { InjectionToken } from "@angular/core";
import { Wrapper, FormWrapper } from "./wrapper.interface";
import { BaseConfig } from "./config.interface";

export const WRAPPER_TOKEN: InjectionToken<Wrapper<BaseConfig>> = new InjectionToken<Wrapper<BaseConfig>>('Wrapper');
export const V_FORM_CONTROL_TOKEN: InjectionToken<FormWrapper> = new InjectionToken<FormWrapper>('VFormControl');
export const V_COMPONENT_CONTAINER = new InjectionToken('V_COMPONENT_CONTAINER');
export const V_SKIP_REGISTER = new InjectionToken('V_SKIP_REGISTER');